module.exports = __webpack_public_path__ + "static/media/end-time.a6bf9b86.mp3";